"use strict";
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var $fill = require("../internals/array-fill");
var toBigInt = require("../internals/to-big-int");
var classof = require("../internals/classof");
var call = require("../internals/function-call");
var uncurryThis = require("../internals/function-uncurry-this");
var fails = require("../internals/fails");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var slice = uncurryThis("".slice);
var CONVERSION_BUG = fails(function() {
  var count = 0;
  new Int8Array(2).fill({ valueOf: function() {
    return count++;
  } });
  return count !== 1;
});
exportTypedArrayMethod("fill", function fill(value) {
  var length = arguments.length;
  aTypedArray(this);
  var actualValue = slice(classof(this), 0, 3) === "Big" ? toBigInt(value) : +value;
  return call($fill, this, actualValue, length > 1 ? arguments[1] : void 0, length > 2 ? arguments[2] : void 0);
}, CONVERSION_BUG);
